import { useEffect, useRef } from 'react';
import { Send } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import ButtonComponent from 'components/design-system/Button/Button';
import Heading from 'components/design-system/Heading/Heading';
import { ListaCheckbox } from 'components/design-system/ListaCheckbox/ListaCheckbox';
import Text from 'components/design-system/Text/Text';
import { formeateaDireccion } from 'helpers/manejoDatos';
import { ObtieneListaSucursales } from 'hooks/useServices';

export const SeleccionarSucursal = ({
  setFieldValue,
  values,
  errors,
  touched,
  disabled
}) => {
  const codigoEmpresaState = values.negocio.value;

  const { cargandoListaSucursales, handleListaSucursales, listaSucursales } =
    ObtieneListaSucursales(codigoEmpresaState);

  const handleSeleccionados = seleccionados => {
    setFieldValue('sucursalesSeleccionadas', seleccionados);
  };

  // useRef almacena el valor anterior de codigoEmpresaState
  const prevCodigoEmpresaState = useRef(codigoEmpresaState);

  useEffect(() => {
    // Se verifica si el valor actual de codigoEmpresaState es diferente al valor anterior
    if (
      codigoEmpresaState &&
      codigoEmpresaState !== prevCodigoEmpresaState.current
    ) {
      prevCodigoEmpresaState.current = codigoEmpresaState; // Actualizamos el valor de prevCodigoEmpresaState
      handleListaSucursales(codigoEmpresaState); // Se ejecuta la función handleListaSucursales
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Dependencia del useEffect;

  useEffect(() => {
    if (listaSucursales.length > 0) {
      setFieldValue('sucursalesSeleccionadas', listaSucursales);
    }
  }, [listaSucursales, setFieldValue, values.sucursalesSeleccionadas]);

  return (
    <div className="col-span-12 xl:col-span-10">
      <Text className="mb-3">
        Sucursales que se te asignaran para administrar el negocio seleccionado
      </Text>

      {cargandoListaSucursales ? (
        <Skeleton className="w-full h-96 rounded" variant="rounded" />
      ) : (
        <ListaCheckbox
          ocultaBotonTodoSeleccionado={true}
          ocultaCheckBox={true}
          isTodoSeleccionado={false}
          isError={errors.sucursalesSeleccionadas}
          estado={
            errors.sucursalesSeleccionadas
              ? { tipo: 'error', mensaje: errors.sucursalesSeleccionadas }
              : null
          }
          isTouched={touched.sucursalesSeleccionadas}
          disabled={true} // se desactiva para envitar que se pueda seleccionar
          opciones={listaSucursales}
          opcionesSeleccionadas={listaSucursales}
          handleSeleccionados={handleSeleccionados}
          accesor="codigoSucursal"
          radioButtonLabel="Seleccionar todas las sucursales"
          checkboxRender={item => (
            <div className="ml-2 my-3">
              <Heading type="h5" className="mb-0.5">
                {item.nombreSucursal}
              </Heading>
              <Text>{formeateaDireccion(item)}</Text>
            </div>
          )}
        />
      )}

      <ButtonComponent
        form="solicitud-individual"
        buttonType="submit"
        className="mt-4 h-auto"
      >
        Enviar invitación <Send className="ml-4" />
      </ButtonComponent>
    </div>
  );
};
